import BaseAbility from 'umg-ember-backend/abilities/base';

export default class NewsletterTargetAbility extends BaseAbility {}
